import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoFilledIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.50033 0.541992C3.20963 0.541992 0.541992 3.20963 0.541992 6.50033C0.541992 9.79102 3.20963 12.4587 6.50033 12.4587C9.79102 12.4587 12.4587 9.79102 12.4587 6.50033C12.4587 3.20963 9.79102 0.541992 6.50033 0.541992ZM6.50033 3.79199C6.20117 3.79199 5.95866 4.0345 5.95866 4.33366C5.95866 4.63281 6.20117 4.87533 6.50033 4.87533H6.50574C6.8049 4.87533 7.04741 4.63281 7.04741 4.33366C7.04741 4.0345 6.8049 3.79199 6.50574 3.79199H6.50033ZM7.04199 6.50033C7.04199 6.20117 6.79948 5.95866 6.50033 5.95866C6.20117 5.95866 5.95866 6.20117 5.95866 6.50033V8.66699C5.95866 8.96615 6.20117 9.20866 6.50033 9.20866C6.79948 9.20866 7.04199 8.96615 7.04199 8.66699V6.50033Z",
		fill: "currentColor"
	})
});
export default SvgInfoFilledIcon;
